// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nk-modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 22px;
  color: #888;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.nk-modal-close:hover {
  background: #f0f0f0;
  color: #333;
}

.nk-modal-icon {
  text-align: center;
  font-size: 38px;
  color: #e6a817;
  margin-bottom: 10px;
}

.nk-modal-title {
  margin: 0 0 12px;
  text-align: center;
  font-size: 1.25rem;
  color: #333;
}

.nk-modal-body {
  font-size: 0.95rem;
  line-height: 1.55;
  color: #555;
  margin-bottom: 20px;
}

.nk-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nk-modal-btn {
  display: block;
  width: 100%;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  background-color: #5616ea;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.nk-modal-btn:hover {
  background-color: #4a14d6;
}

.nk-modal-btn.secondary {
  background-color: transparent;
  color: #5616ea;
  border: 1.5px solid #5616ea;
}

.nk-modal-btn.secondary:hover {
  background-color: #5616ea10;
}
`, "",{"version":3,"sources":["webpack://./src/components/NoKnowledgeModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".nk-modal-close {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 22px;\r\n  color: #888;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.nk-modal-close:hover {\r\n  background: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.nk-modal-icon {\r\n  text-align: center;\r\n  font-size: 38px;\r\n  color: #e6a817;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.nk-modal-title {\r\n  margin: 0 0 12px;\r\n  text-align: center;\r\n  font-size: 1.25rem;\r\n  color: #333;\r\n}\r\n\r\n.nk-modal-body {\r\n  font-size: 0.95rem;\r\n  line-height: 1.55;\r\n  color: #555;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.nk-modal-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.nk-modal-btn {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.nk-modal-btn:hover {\r\n  background-color: #4a14d6;\r\n}\r\n\r\n.nk-modal-btn.secondary {\r\n  background-color: transparent;\r\n  color: #5616ea;\r\n  border: 1.5px solid #5616ea;\r\n}\r\n\r\n.nk-modal-btn.secondary:hover {\r\n  background-color: #5616ea10;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
